export default __webpack_public_path__ + "static/media/rosia_1.e238141e.jpeg";